import { SupportedHostAppSchema } from 'renderer/features/products-page/schemas/products.schemas';
import { PricesSchema } from 'renderer/features/purchase-page/schemas/prices.schema';
import { PaymentMethodSchema } from 'renderer/features/settings/schemas/paymentMethods.schemas';
import { z } from 'zod';

// Detail
const BaseTransactionSchema = z.object({
  _id: z.string(),
  email: z.string().optional(),
  // stripeId: z.string().optional(),
  amount: z.number(),
  status: z.string(),
  createdAt: z.string(),
  productName: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  category: z.string().optional(),
  refundedAmount: z.number(),
});

export type BaseTransaction = z.infer<typeof BaseTransactionSchema>;

export const TransactionListSchema = BaseTransactionSchema.array();

export const TransactionDetailsSchema = BaseTransactionSchema.extend({
  embeddedPaymentMethod: PaymentMethodSchema.optional(),
  fullPrice: z.number().optional(),
  prices: PricesSchema.optional(),
  originalSerial: z.string().optional(),
  paymentMethodId: z.string().optional(),
  platform: z.string().optional(),
  hostApplication: SupportedHostAppSchema.optional(),
  productId: z.string().optional(),
  // productId: ProductDetailsSchema.partial().or(z.string()).optional(),
  quantity: z.number().optional(),
  serials: z.string().array(),
  updatedAt: z.string().optional(),
  // refunds: RefundListSchema.optional(),
  // userId: UserDetailsSchema.optional(),
  upgradeOrDowngrade: z.string().optional(),
  note: z.string().optional(),
});

export const TransactionsSchema = TransactionDetailsSchema.array();

export type GetTransactionDetailResponse = z.infer<
  typeof TransactionDetailsSchema
>;
export type TransactionDetails = GetTransactionDetailResponse;
export type GetTransactionDetailRequest = string;

// List
export const ListTransactionsResponseSchema = z.object({
  docs: TransactionListSchema,
  totalDocs: z.number(),
});

export type ListTransactionsResponse = z.infer<
  typeof ListTransactionsResponseSchema
>;

export interface ListTransactionsRequest {
  page: number;
  limit: number;
  search?: string;
  sortBy?: string;
  sortOrder: string;
  filter?: any;
}

export interface UpdateTransactionNoteRequest {
  transactionId: string;
  note: string;
}

export const UpdateTransactionNoteResponseSchema = TransactionDetailsSchema;
export type UpdateTransactionNoteResponse = TransactionDetails;
